export enum AppRoleAllowedMemberType {
    All = "All",
    Application = "Application",
    User = "User"
} 